/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authApiKeyGetJwtFromKey } from "../../funcs/authApiKeyGetJwtFromKey.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetJwtFromKeyRequest$inboundSchema,
};

export const tool$authApiKeyGetJwtFromKey: ToolDefinition<typeof args> = {
  name: "auth-api-key-get-jwt-from-key",
  description: `Exchange API key for a JWT token

Exchange an API key for a JWT token`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authApiKeyGetJwtFromKey(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
